import { makeStyles } from '@material-ui/core/styles';
import { efesBrown, efesOrange } from '../../theme';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    float: 'right',
  },
  actionsContainer: {
    marginBottom: theme.spacing(1),
  },
  stepLabel: {
    cursor: 'pointer',
  },
  stepIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: 16,
    fontWeight: 'bold',
    position: 'relative',
    right: 18,
    '& span': {
      marginRight: 20,
    },
  },
  stepIconCurrent: {
    backgroundColor: efesBrown,
    '& > i.icon': {
      color: theme.palette.white.main,
    },
  },
  stepIconLocked: {
    backgroundColor: theme.palette.white.main,
  },
  stepIconTouched: {
    backgroundColor: efesOrange,
    borderColor: efesOrange,
    cursor: 'pointer',
    '& > i.icon': {
      color: theme.palette.white.main,
    },
  },
  stepLabelText: {
    cursor: 'pointer',
    fontSize: 16,
  },
  stepLabelTextTouched: {
    fontWeight: 'bold',
  },
}));

export default useStyles;
